import { useMemo } from 'react'
import { FC } from 'react'
import { SegmentButton } from 'components/features/pfm/SegmentButton/SegmentButton'
import * as styles from 'components/features/pfm/SegmentButton/CommentLikeButton.styl'
import LikeIcon from 'icons/like.svg'
import LikedIcon from 'icons/liked.svg'
import { AnalyticsEvent } from 'interfaces/analytics'

type CommentLikeButtonProps = {
  counter: number
  pressed?: boolean
  disabled?: boolean
  onClick?: () => void
}

export const CommentLikeButton: FC<CommentLikeButtonProps> = (props) => {
  const { counter, disabled, pressed, onClick } = props

  let contentChild = (
    <SegmentButton.Icon size={ 12 } src={ LikedIcon } />
  )

  if (!pressed) {
    contentChild = (
      <SegmentButton.Icon size={ 12 } src={ LikeIcon } />
    )
  }

  const analyticsAction = useMemo<AnalyticsEvent>(() => ({
    category: 'module-feed_post_comment',
    action: 'toggle-like',
    label: pressed ? 'unlike' : 'like',
  }), [pressed])

  return (
    <SegmentButton
      pressed={ !!pressed }
      disabled={ disabled }
      analyticsAction={ analyticsAction }
      onClick={ onClick }
    >
      <SegmentButton.Segment
        className={ styles.commentLikeButtonSegment }
      >
        { contentChild }
        <SegmentButton.Text text={ String(counter) } />
      </SegmentButton.Segment>
    </SegmentButton>
  )
}
